import React from "react";

export const CardControlsErrorPage = (props) => {
  return (
    <div className="card-controls-error-page">
      <h2 className="text-centered bold">Oops, something went wrong!</h2>
      <div className="text-centered">Something went wrong, please try again.</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/error-page/card-controls-error-page.component.js